import { all, call, put, takeLatest } from "redux-saga/effects";
import { Action_GetListChiNhanh  } from "actions/DanhMuc/ChiNhanh/actionTypes";
import { Index_GetListChiNhanhSuccess } from "actions/DanhMuc/ChiNhanh";
import chinhanhApi from "service/DanhMucService/ChiNhanhApi";
import { pushNotification } from "utils/notifications";
import { CheckTokenReload } from 'utils/utils';

function* Saga_getListChiNhanh(action) {
  try {
    const response = yield call(chinhanhApi.listChiNhanh, action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_GetListChiNhanhSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}


function* watch_getListChiNhanh() {
  yield takeLatest(Action_GetListChiNhanh, Saga_getListChiNhanh);
}
//endregion watchAPI

export default function* sagas() {
  yield all([ watch_getListChiNhanh()]);
}
